// Local-date helpers for the cook log. `made_on` is a DATE column (no time),
// so it must be created and formatted in the user's LOCAL day, never UTC —
// otherwise a date like "2026-06-14" parsed as UTC midnight reads as the 13th
// in a negative-offset timezone, breaking same-day dedup and the displayed day.

function pad(value: number): string {
    return value.toString().padStart(2, "0");
}

/** Today as a local `YYYY-MM-DD` string (matches the `made_on` date column). */
export function todayLocalDate(): string {
    const now = new Date();
    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

/** Parse a `YYYY-MM-DD` date-only string into a Date at LOCAL midnight. */
function parseDateOnly(value: string): Date {
    const [year, month, day] = value.split("-").map(Number);
    return new Date(year, month - 1, day);
}

/**
 * Format a `made_on` date for the log: "Today" / "Yesterday" for the last two
 * days, otherwise an absolute date ("Jun 14" same year, "Jun 14, 2025" prior).
 */
export function formatLogDate(madeOn: string): string {
    const date = parseDateOnly(madeOn);
    if (Number.isNaN(date.getTime())) return "";

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const diffDays = Math.round((today.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "Yesterday";

    const sameYear = date.getFullYear() === today.getFullYear();
    return new Intl.DateTimeFormat("en-US", sameYear
        ? { month: "short", day: "numeric" }
        : { month: "short", day: "numeric", year: "numeric" }
    ).format(date);
}
